import { exitDeviceFullscreen } from "../../../messaging/fullscreenUtils"

export const handleOpenPushMenuMobile = (): void => {
    const pushMenu = document.querySelector(".nav_list") as HTMLElement
    if (pushMenu !== null) {
        exitDeviceFullscreen()
        pushMenu.click()
    }
}
